import { useNavigate, useParams } from 'react-router-dom';
import { decryptURL } from 'utils/functions';
import Container from 'components/Container';
import EtiquetaModal from 'components/Modals/EtiquetaModal';
import Header from 'components/Header';

const Etiqueta = () => {
  const navigate = useNavigate();
  const { hash } = useParams();
  const params = decryptURL(hash);

  return (
    <Container>
      <Header titulo="Imprimir Etiquetas" />
      <EtiquetaModal itens={params || []} callback={() => navigate(-1)} />
    </Container>
  );
};

export default Etiqueta;
